import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null=loading, false=logged out, obj=logged in
    const [error, setError] = useState("");

    const check = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        check();
    }, [check]);

    const login = async (email, password) => {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.access_token) {
                localStorage.setItem("ruiz_token", data.access_token);
            }
            setUser(data.user);
            return true;
        } catch (e) {
            const detail = e.response?.data?.detail;
            const msg =
                typeof detail === "string"
                    ? detail
                    : Array.isArray(detail)
                        ? detail.map((d) => d.msg || "").join(" ")
                        : e.message || "Login failed";
            setError(msg);
            return false;
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            /* ignore */
        }
        localStorage.removeItem("ruiz_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, error, login, logout, check }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
